<template>
  <div class="history">
    <v-base-card>
      <template v-slot:heading>
        半蔵門学校 申し込み一覧
      </template>

      <template v-slot:content>
        <v-row class="mb-0 pb-0">
          <v-col cols="2">
            <v-select
              v-model="selectedGrade"
              :items="grades.map(grade => grade.name)"
              label="学年"
              clearable
            ></v-select>
          </v-col>
          <v-col cols="2">
            <v-select
              v-model="selectedSubject"
              :items="subjects.map(subject => subject.name)"
              label="教科"
              clearable
            ></v-select>
          </v-col>
          <v-col cols="3">
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateRangeText"
                  label="申込日"
                  prepend-icon="mdi-calendar"
                  readonly
                  clearable
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dates"
                no-title
                range
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="primary"
                  @click="menu = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.menu.save(dates)"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="2">
            <v-select
              v-model="selectedStatus"
              :items="status.map(status => status.name)"
              label="ステータス"
            ></v-select>
          </v-col>
          <v-col cols="3" class="d-flex">
            <v-btn class="mt-5 ml-auto" small color="#4a81aa" dark>PDFダウンロード</v-btn>
          </v-col>
        </v-row>
        <v-data-table
          :headers="headers"
          :items="filterdApplications"
          disable-pagination
          show-select
          hide-default-footer
          mobile-breakpoint=10
        >
          <!-- TODO: チェックボックすの部分はvuetifyに頼らず作った方がよさげ -->
          <template #[`item.data-table-select`]="{ isSelected, select, item }">
            <v-simple-checkbox
              v-if="item.status !== 'delete'"
              :value="isSelected"
              @input="select($event)"
              :ripple="false"
            />
          </template>
          <template #[`item.subject_code`]="{ item }">
            <v-subject-chip :type="subjects.find(subject => subject.code === item.subject_code).type">
              {{ subjects.find(subject => subject.code === item.subject_code).name }}
            </v-subject-chip>
          </template>
          <template #[`item.status`]="{ item }">
            <v-chip dark class="my-1 mx-2" :class="getStatusClass(item.status)">{{status.find(s => s.code === item.status).name}}</v-chip>
          </template>
          <template #[`item.delete`]="{ }">
            <v-btn icon @click.stop="$emit('click')">
              <v-icon dark>
                mdi-delete
              </v-icon>
            </v-btn>
          </template>
          <template #[`item.preview`]="{ }">
            <v-btn small color="secondary" dark @click.stop="showImage('question')">確認</v-btn>
          </template>
        </v-data-table>
      </template>
    </v-base-card>

    <v-dialog
      v-model="previeDialog"
      max-width="50%"
    >
      <v-card>
        <v-img
          v-if="dialogImage"
          :src="this.dialogImage"
        />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from 'moment'
import VBaseCard from '@/components/molecules/BaseCard'
import VSubjectChip from '@/components/atoms/SubjectChip'

export default {
  components: {
    VBaseCard,
    VSubjectChip,
  },
  data () {
    return {
      previeDialog: false,
      menu: false,
      dates: [],
      dialogImage: require('@/assets/img/que_1.png'),
      headers: [
        { text: 'ログインID', align: 'start', value: 'login_id' },
        { text: '学年', align: 'center', value: 'grade' },
        { text: '教科', align: 'center', value: 'subject_code' },
        { text: '試験名', align: 'center', value: 'name' },
        { text: '申込日', align: 'center', value: 'applicated_date' },
        { text: 'ステータス', align: 'center', value: 'status' },
        { text: 'プレビュー', align: 'center', value: 'preview' },
        { text: '取消', align: 'center', value: 'delete', sortable: false },
      ],
      applications: [
        {
          id: 1,
          login_id: 'en1-004578',
          grade: '中学1年',
          subject_code: 'en',
          name: '1学期中間テスト',
          status: 'not-done',
          applicated_date: moment(new Date(2020, 9, 14, 12, 25)).format('YYYY/MM/DD HH:mm'),
        },
        {
          id: 2,
          login_id: 'ko2-004578',
          grade: '中学2年',
          subject_code: 'ko',
          name: '1学期中間テスト',
          status: 'not-done',
          applicated_date: moment(new Date(2020, 9, 13, 14, 5)).format('YYYY/MM/DD HH:mm'),
        },
        {
          id: 3,
          login_id: 'su2-004578',
          grade: '中学2年',
          subject_code: 'su',
          name: '1学期中間テスト',
          status: 'not-done',
          applicated_date: moment(new Date(2020, 9, 13, 11, 34)).format('YYYY/MM/DD HH:mm'),
        },
        {
          id: 4,
          login_id: 'ko3-004578	',
          grade: '中学3年',
          subject_code: 'ko',
          name: '1学期中間テスト',
          status: 'not-done',
          applicated_date: moment(new Date(2020, 9, 11, 16, 54)).format('YYYY/MM/DD HH:mm'),
        },
        {
          id: 5,
          login_id: 'sha3-004578',
          grade: '中学3年',
          subject_code: 'sha',
          name: '1学期中間テスト',
          status: 'done',
          applicated_date: moment(new Date(2020, 9, 10, 10, 14)).format('YYYY/MM/DD HH:mm'),
        },
        {
          id: 6,
          login_id: 'sha3-004578',
          grade: '中学3年',
          subject_code: 'sha',
          name: '1学期中間テスト',
          status: 'delete',
          applicated_date: moment(new Date(2020, 9, 10, 11, 25)).format('YYYY/MM/DD HH:mm'),
        },
      ],
      selectedGrade: null,
      grades: [
        { code: '1', name: '中学1年' },
        { code: '2', name: '中学2年' },
        { code: '3', name: '中学3年' }
      ],
      selectedSubject: null,
      subjects: [
        { code: 'ko', type: 'kokugo', name: '国語' },
        { code: 'sha', type: 'shakai', name: '社会' },
        { code: 'su', type: 'suugaku', name: '数学' },
        { code: 'ri', type: 'rika', name: '理科' },
        { code: 'en', type: 'eigo', name: '英語' }
      ],
      selectedStatus: '未処理',
      status: [
        { code: null, name: '全て' },
        { code: 'not-done', name: '未処理' },
        { code: 'done', name: '処理済み' },
        { code: 'delete', name: '取消' },
      ]
    }
  },

  computed: {
    filterdApplications() {
      return this.applications
          .filter(application => { return this.selectedGrade ? application.grade === this.selectedGrade : application})
          .filter(application => {
            if (!this.selectedSubject) return application
            const subject = this.subjects.find(subject => subject.name === this.selectedSubject)
            return application.subject_code === subject.code
          })
          .filter(application => {
            if (this.dates.length === 0) return application
            const from = new Date(this.dates[0])
            const applicatedAt = new Date(application.applicated_date)
            const to   = new Date(this.dates[1])
            return from <= applicatedAt && applicatedAt <= to
          })
          .filter(application => {
            if (!this.selectedStatus || this.selectedStatus === '全て') return application
            const status = this.status.find(status => status.name === this.selectedStatus)
            return application.status === status.code
          })
    },
    dateRangeText: {
      get() {
        return this.dates.join(' ~ ')
      },
      set() {
        this.dates = []
      }
    },
  },

  methods: {
    getStatusClass(status) {
      let className = 'chip__status'
      if (status === 'not-done') return className + '-applicate'
      else if (status === 'done') return className + '-contracted'
      else if (status === 'delete') return className + '-deleted'
      else return className + '-shipped'
    },
    showImage() {
      this.previeDialog = !this.previeDialog;
    },
  }
}
</script>

<style lang="stylus" scoped>

.select
  font-size: 11px !important;

.chip
  &__status
    &-applicate
      background-color #3E90C6 !important
      width 104px
      height 19px !important
      font-size 10px !important
      font-weight bold
      border-bottom 1px solid #c4c4c4
      display inline-block

    &-contracted
      background-color #4caf50 !important
      width 104px
      height 19px !important
      font-size 10px !important
      font-weight bold
      border-bottom 1px solid #337f36
      display inline-block

    &-deleted
      background-color #808080 !important
      width 104px
      height 19px !important
      font-size 10px !important
      font-weight bold
      border-bottom 1px solid #696767
      display inline-block

    &-shipped
      background-color #8e8e8e !important
      width 104px
      height 19px !important
      font-size 10px !important
      font-weight bold
      border-bottom 1px solid #6d6464
      display inline-block
</style>
